import React from 'react';

export const RuDistanceModal = {
  title: 'Distance From Source (km)',
  body: (
    <div>
      <p>
        The distance from the tsunami event source to the runup location.
      </p>
    </div>
  ),
};
